import { inject } from "@angular/core";
import { CanDeactivateFn, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { UnsavedChangesService } from "../services/unsaved-changes.service";

/**
 * PURPOSE: shows a confirmation dialog when a user tries to navigate away from a page with unsaved changes.
 */
export const CanDeactivateGuard: CanDeactivateFn<CanDeactivateComponent> = (
  component: CanDeactivateComponent
) => {
  const dialogService: UnsavedChangesService = inject(UnsavedChangesService);

  // If the component doesn't have a canDeactivate method or returns true, allow the navigation
  if (!component.canDeactivate) {
    return true;
  }

  const result = component.canDeactivate();

  // If the component says we can deactivate (no unsaved changes), allow it
  if (result === true) {
    return true;
  }

  // For async results that resolve to true, allow navigation
  if (result instanceof Observable || result instanceof Promise) {
    return result;
  }

  // Otherwise, show confirmation dialog
  return dialogService.showConfirmationDialog();
};

export interface CanDeactivateComponent {
  canDeactivate: () =>
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree;
}
